import { type JSX } from 'react';

import { OddsButton } from '@cx-modules/ui';

import { useBetslip } from '../../hooks/useBetslip';
import { useBookmakerData } from '../../hooks/useBookmakerData';
import { useSelector } from '../../providers/StoreProvider';
import { type OddsShown, oddsShownType, type OnOddsButtonClick } from '../../types';

interface BestOddsButtonProps {
  bestOddsText: string | number;
  betId: number;
  bookieCode: string;
  disableStreamer: boolean;
  marketId: number;
  oddsShown: OddsShown;
  onOddsButtonClick?: OnOddsButtonClick;
  renderBadge: boolean;
  steamOrDrift: string;
}

export const BestOddsButton = ({
  bestOddsText,
  betId,
  bookieCode,
  disableStreamer,
  oddsShown,
  onOddsButtonClick,
  renderBadge,
  steamOrDrift,
}: BestOddsButtonProps): JSX.Element => {
  const allowOddsClickout = useSelector(store => store.allowOddsClickout);

  const { isBookieBetSelected, toggleBetslipBet } = useBetslip({
    betId,
    betOdds: bestOddsText,
    bookieCode,
  });

  const isNonClickable = oddsShown === oddsShownType.OC_NON_CLICKABLE;
  const buttonBookieCode = isNonClickable ? oddsShownType.OC_NON_CLICKABLE : bookieCode;
  const { bookmakerData: bookmakerConfig } = useBookmakerData(bookieCode);

  const onClickHandler = () => {
    if (isNonClickable || !allowOddsClickout) return;

    if (onOddsButtonClick) {
      return onOddsButtonClick('best_odds_click', betId, bookieCode);
    }
    toggleBetslipBet();
  };

  return (
    <OddsButton
      bookieCode={buttonBookieCode}
      bookmakerConfig={bookmakerConfig}
      data-testid="bet-odds"
      disableAnimation={disableStreamer}
      disabled={isNonClickable || !allowOddsClickout}
      isSelected={!isNonClickable && isBookieBetSelected}
      isUnsupported={!allowOddsClickout}
      onClick={onClickHandler}
      renderBadge={renderBadge}
      steamOrDrift={steamOrDrift}
    >
      {bestOddsText || 'SP'}
    </OddsButton>
  );
};
